export const toastTypes = {
    success: "success",
    error: "error",
    warn: "warn",
    info: "info",
  }
  